import { BaseModel } from "@red/data-access";
import { Expose, Type } from "class-transformer";
import { IAppointmentType } from '../interfaces/appointment-type.interface';
import { ICarrerProgression } from '../interfaces/career-progression.interface';
import { IProjectTransactionGrossComm } from '../interfaces/project-transaction-gross-comm.interface';
import { AppointmentTypeModel } from "./appointment-type.model";

export class ProjectTransactionGrossCommModel extends BaseModel implements IProjectTransactionGrossComm{
  @Expose()
  value!: number;

  @Expose()
  withoutGst!: number;

  @Expose()
  gst!: number;

  @Expose()
  withGst!: number;
}
